<template>
  <div class="g-container">
    <div class="page-login-wrap">
      <div class="page-login">
        <cmp-login-pic></cmp-login-pic>

        <div class="content">
          <!-- <h1 class="title">登录</h1> -->

          <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>

          <el-form @keyup.enter.native="submitForm('ruleForm')" :label-position="`top`" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="form cus-form-top">
            <el-form-item label="账号" prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入手机号"></el-input>
            </el-form-item>

            <el-form-item label="密码" prop="pass">
              <el-input type="password" v-model="ruleForm.pass" placeholder="请输入密码"></el-input>
              <div class="el-form-item__error" v-if="passValid && errorMsg">{{errorMsg}}</div>
            </el-form-item>

            <el-form-item label="验证码" prop="verificationCode" style="position:relative;" v-if="showVerify">
              <el-input v-model="ruleForm.verificationCode" placeholder="请输入图片验证码"></el-input>
              <img src="/admin/getImgCode.do" alt="" style="width:100px;height:30px;position:absolute;right:10px;top:5px;">
            </el-form-item>
          </el-form>

          <!-- <div class="other-way mt-20">
            <router-link tag="span" :to="{path: '/register?type=forget'}" class="m-btn">忘记密码</router-link>
            <router-link tag="span" :to="{path: '/register?type=add'}" class="m-btn fr">注册账户</router-link>
          </div> -->

          <el-button class="btn-sure" type="primary" @click="submitForm('ruleForm')">确定</el-button>
        </div>
      </div>

      <!-- <cmp-footer></cmp-footer> -->
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { validate } from '@/utils/util'
import cmpLoginPic from './components/login-pic'
import cmpTab from '@cmp/tab'
// import cmpFooter from '@cmp/footer'
export default {
  components: {
    cmpLoginPic,
    cmpTab
    // cmpFooter
  },
  data() {
    let validatePhoneNo = (rule, value, callback) => {
      if (!validate(value, 'phone')) {
        callback(new Error('手机号不存在'))
      } else {
        callback()
      }
    }
    let validatePass = (rule, value, callback) => {
      if (!validate(value, 'password')) {
        this.passValid = false
        callback(new Error('6-20位数字、字母、特殊字符至少包含两种'))
      } else {
        this.passValid = true
        callback()
      }
    }
    return {
      activeVal: '1',
      tabList: [
        {
          name: '登录',
          val: '1'
        },
        {
          name: '注册',
          val: '2'
        }
      ],

      errorMsg: '', // 错误提示
      passValid: false, // 密码是否校验通过
      ruleForm: {
        name: '',
        pass: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhoneNo, trigger: 'blur' }
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入图片验证码', trigger: 'blur' }
        ]
      },
      showVerify: this.$store.state.user.showVerify
    }
  },
  methods: {
    eventTabClick(val) {
      console.log(val)
      this.$router.push('/register?type=add')
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$store
            .dispatch('LoginUser', {
              phone: this.ruleForm.name,
              password: md5(this.ruleForm.pass),
              rpassword: btoa(this.ruleForm.pass),  // base64
              verificationCode: this.ruleForm.verificationCode
            })
            .then(() => {
              this.$http1.post('/login/webLogin', {
                loginName: '18672188180',
                password: 'tj12345678'
              })
                .then(res => {
                  this.getUserInfo()

                })
              // // this.$router.push({ path: '/home' })
              // history.back()
            })
            .catch(msg => {
              this.errorMsg = msg
              this.showVerify = this.$store.state.user.showVerify
            })
        } else {
          return false
        }
      })
    },
    // getUserInfo() {
    //   this.$http.post('/login/getRoleFunction', {}).then(
    //     res => {
    //       if (res.success) {
    //         let data = res.result
    //         localStorage.setItem('firstHref', data.firstUrl || '/nodata')
    //         this.$router.push({ path: data.firstUrl || '/nodata' })
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     },
    //     error => {
    //       this.$message.error(error.msg || '服务器异常')
    //     }
    //   )
    // }
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // }
  }
}
</script>

<style lang="scss" scoped>
.g-container {
  padding-top: 0;

  .page-login-wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url(~@images/login-bg.jpg) no-repeat center center;
    background-size: cover;
  }
  .page-login {
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      padding: 80px 60px;
      width: 620px;
      height: 592px;
      box-sizing: border-box;
      background: url(~@images/login-bor.png) no-repeat center center;
      background-size: 100% 100%;
      box-shadow: 0px 10px 20px 0px rgba(181, 177, 221, 0.3);
      h1.title {
        position: relative;
        padding-bottom: 14px;
        margin-bottom: 60px;
        font-size: 24px;
        color: $primary;
        letter-spacing: 5px;
        &:after {
          display: block;
          content: '';
          position: absolute;
          left: 3px;
          bottom: 0;
          width: 20px;
          height: 4px;
          background: rgba(5, 144, 255, 1);
        }
      }
      .btn-sure {
        width: 100%;
        margin-top: 60px;
      }
      .form {
        .el-form-item {
          margin-bottom: 30px;
          height: 65px;
        }
      }
    }

    /deep/ .el-form-item {
      margin-bottom: 15px;
    }
    /deep/ .el-form-item__label {
      padding: 0;
      color: $primary;
    }
  }
}
</style>


